import { createContext, useContext } from "react";
import type { LeaveApplication } from "../types/leave-application.types";

export interface LeaveApplicationOverviewContextType {
  record: LeaveApplication | null;
  refetch: () => Promise<void>;
  summaryKey: number;
}

const LeaveApplicationOverviewContext =
  createContext<LeaveApplicationOverviewContextType | null>(null);

export function useLeaveApplicationOverview() {
  const ctx = useContext(LeaveApplicationOverviewContext);
  if (!ctx) {
    throw new Error(
      "useLeaveApplicationOverview must be used within LeaveApplicationOverviewContext.Provider",
    );
  }
  return ctx;
}

export default LeaveApplicationOverviewContext;
